import { trackMixpanelEvent } from '../utils/general';

export const TRANSLATION_KEY = 'STATIC.PAGES.ANALYSIS_CHAT.CONNECTIONS';

const CONNECTIONS_BASE = 'interactive-service/connections';

export const CONNECTIONS_PATHS = {
    LIST: CONNECTIONS_BASE,
    start: connectionId => `${CONNECTIONS_BASE}/${connectionId}/start`,
    connection: connectionId => `${CONNECTIONS_BASE}/${connectionId}`,
};

export const CONNECTION_TYPES = {
    MCP: 'mcp',
    CONNECTION: 'connection',
};

export const CONNECTION_STATES = {
    CONNECTED: 'connected',
    NOT_CONNECTED: 'not_connected',
    EXPIRED: 'expired',
    NEEDS_UPDATE: 'needs_update',
    NOT_LINKED: 'not_linked',
};

export const SLACK_CONNECTION_ID = 'slack';

export const CONNECTION_TYPE_ORDER = [CONNECTION_TYPES.MCP, CONNECTION_TYPES.CONNECTION];

export const SEARCH_MIN_ITEMS = 5;

export const TRIGGER_MAX_LOGOS = 3;

export const RESULT_PARAM = 'connection_result';
export const ERROR_PARAM = 'connection_error';
export const CONNECTION_ID_PARAM = 'connection_id';
export const CONNECTION_URL_PARAMS = [RESULT_PARAM, ERROR_PARAM, CONNECTION_ID_PARAM];

export const CONNECTION_SURFACES = {
    HEADER: 'header',
    ANSWER_ACTION: 'answer_action',
};

export const CONNECTION_EVENTS = {
    CONNECT_CLICKED: 'Connection Connect Clicked',
    INTRO_OPENED: 'Connection Intro Opened',
    INTRO_CONTINUED: 'Connection Intro Continued',
    INTRO_CANCELLED: 'Connection Intro Cancelled',
    OAUTH_STARTED: 'Connection OAuth Started',
    CONNECTED: 'Connection Connected',
    CONNECT_FAILED: 'Connection Connect Failed',
    DISCONNECT_CLICKED: 'Connection Disconnect Clicked',
    DISCONNECTED: 'Connection Disconnected',
    DISCONNECT_FAILED: 'Connection Disconnect Failed',
};

const CONNECTION_EVENT_PREFIX = 'Agent Chat';

export const trackConnectionEvent = (eventName, params) =>
    trackMixpanelEvent(CONNECTION_EVENT_PREFIX, eventName, params);

export const connectionEventProperties = (connection, surface) => ({
    connectionId: connection?.id,
    connectionType: connection?.type,
    connectionState: connection?.state,
    ...(surface && { surface }),
});

export const CONNECT_ERROR_KEYS = {
    not_available: 'NOT_AVAILABLE',
    not_entitled: 'NOT_ENTITLED',
    session_expired: 'SESSION_EXPIRED',
    authorization_not_completed: 'NOT_COMPLETED',
    state_expired: 'STATE_EXPIRED',
    exchange_failed: 'EXCHANGE_FAILED',
    workspace_conflict: 'WORKSPACE_CONFLICT',
    organization_has_workspace: 'ORGANIZATION_HAS_WORKSPACE',
    workspace_not_connected: 'WORKSPACE_NOT_CONNECTED',
    already_linked: 'ALREADY_LINKED',
    incomplete_authorization: 'INCOMPLETE_AUTHORIZATION',
    unexpected: 'UNEXPECTED',
};
export const GENERIC_ERROR_KEY = 'FAILED';

export const TOAST_AUTO_CLOSE_MS = 6000;

export const toastKey = key => `${TRANSLATION_KEY}.TOASTS.${key}`;

export const disconnectToastKey = type => toastKey(`DISCONNECTED.${type?.toUpperCase() ?? 'DEFAULT'}`);

export const resultToastKey = result => toastKey(`RESULTS.${result.toUpperCase()}`);

export const connectErrorToastKey = code => toastKey(`ERRORS.${CONNECT_ERROR_KEYS[code] ?? GENERIC_ERROR_KEY}`);

export const groupLabelKey = type => `${TRANSLATION_KEY}.GROUPS.${type.toUpperCase()}`;

export const descriptionKey = type => `${TRANSLATION_KEY}.DESCRIPTIONS.${type.toUpperCase()}`;

export const stateKey = state => `${TRANSLATION_KEY}.STATES.${state.toUpperCase()}`;
